import { render, staticRenderFns } from "./StaffRole.vue?vue&type=template&id=121a24a3&"
import script from "./StaffRole.vue?vue&type=script&lang=ts&"
export * from "./StaffRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports